<app-menu>

        <!-- Loading Overlay -->
        <div class="loading-overlay" *ngIf="isLoading">
            <div class="loading-content">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            <p>Loading, please wait...</p>
            </div>
        </div>    
  <div class="min-h-screen bg-[linear-gradient(180deg,#f8fafc_0%,#eef2ff_55%,#f8fafc_100%)]">
    <div class="mx-auto flex w-full max-w-[1800px] flex-col gap-6 px-4 py-6 md:px-6 xl:px-8">
      <section class="wo-hero overflow-hidden rounded-[24px] border border-slate-200/80 bg-purple-900 text-white shadow-[0_24px_55px_-32px_rgba(15,23,42,0.72)]">
        <div class="wo-hero__content px-5 py-5 md:px-7 md:py-6">
            <div class="wo-hero__top">
                <div class="wo-hero__primary">
                    <div class="wo-hero__badges">
                        <span class="wo-hero__badge wo-hero__badge--eyebrow">Contact Details</span>
                    </div>
                    <p class="wo-hero__kicker">Contact Name</p>
                    <h1 class="wo-hero__reference">{{ generalInfoForm.get('contact_organization')?.value}}</h1>
                    <div class="wo-hero__uuid-row">
                        <span class="wo-hero__uuid-icon">
                        <i class="fas fa-link"></i>
                        </span>
                        <span class="wo-hero__uuid">{{ generalInfoForm.get('contact_uuid')?.value || 'N/A' }}</span>
                    </div>                    
                </div>
                <div class="wo-hero__side">
                    <div class="wo-hero__status-card">
                        <span class="wo-hero__status-dot"></span>
                        <span class="wo-hero__status-text">{{ generalInfoForm.get('contact_type')?.value || '' }}</span>
                    </div>

                    <p class="wo-hero__touched">
                        Last Modified:
                        <span>{{ generalInfoForm.get('modifiedDate')?.value || generalInfoForm.get('created')?.value || 'N/A' }}</span>
                    </p>
                </div>
            </div>     
          </div>   
      </section>

    
       <mat-tab-group class="work-order-tab-shell overflow-hidden rounded-[32px] border border-slate-200/80 bg-white/85 shadow-[0_30px_70px_-40px_rgba(15,23,42,0.45)] backdrop-blur" >

            <mat-tab label="General Info">
                <div class="p-4 pb-28 md:p-6 md:pb-32 xl:p-8 xl:pb-32">
                    <form [formGroup]="generalInfoForm">
                        <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                            <mat-card-header class="border-b border-slate-200 bg-slate-300/80 px-6 py-4">
                                <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                                    <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-sky-500/10 text-sky-700">
                                    <i class="fas fa-person"></i>
                                    </span>
                                    <span>General Information</span>
                                </mat-card-title>
                            </mat-card-header>
                            <div class="wo-detail-section__panel">
                                <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-12">
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Organization Name</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="contact_organization" class="wo-inline-control" formControlName="contact_organization" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Category</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="contact_category" class="wo-inline-control" formControlName="contact_category" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Role</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="contact_role" class="wo-inline-control" formControlName="contact_role" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Title</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="contact_title" class="wo-inline-control" formControlName="contact_title" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Contact Prefix</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="contact_name_prefix" class="wo-inline-control" formControlName="contact_name_prefix" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Contact Suffix</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="contact_name_suffix" class="wo-inline-control" formControlName="contact_name_suffix" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Contact Given Name</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="contact_name_given" class="wo-inline-control" formControlName="contact_name_given" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Contact Middle Name</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="contact_name_middle" class="wo-inline-control" formControlName="contact_name_middle" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Contact Family Name</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="contact_name_family" class="wo-inline-control" formControlName="contact_name_family" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Contact Nick Name</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="contact_nickname" class="wo-inline-control" formControlName="contact_nickname" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Main Email</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="contact_email" class="wo-inline-control" formControlName="contact_email" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Main URL</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="contact_url" class="wo-inline-control" formControlName="contact_url" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-3">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Parent Contact UUID</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="contact_parent_uuid" class="wo-inline-control" formControlName="contact_parent_uuid" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-3">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Customer Contact UUID</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="customer_contact_uuid" class="wo-inline-control" formControlName="customer_contact_uuid" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-3">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Insurance Contact UUID</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="insurance_agent_uuid" class="wo-inline-control" formControlName="insurance_agent_uuid" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-3">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Payment Processor Contact UUID</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="payment_processor_uuid" class="wo-inline-control" formControlName="payment_processor_uuid" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-3">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Default Carrier Contact UUID</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="carrier_contact_uuid" class="wo-inline-control" formControlName="carrier_contact_uuid" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">US DOT no</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="us_dot_no" class="wo-inline-control" formControlName="us_dot_no" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Pool ID</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="pool_id" class="wo-inline-control" formControlName="pool_id" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Pool Location</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="pool_location" class="wo-inline-control" formControlName="pool_location" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="ladingNumber">Drop Trailer Party</label>
                                            <input matInput type="string" formControlName="contact_uuid" hidden > 
                                            <input id="drop_trailer_party" class="wo-inline-control" formControlName="drop_trailer_party" />
                                        </div>
                                    </div>
                                    <mat-checkbox formControlName="active">
                                        Active?</mat-checkbox>                                    
                                </div>
                            </div><br>
                            <div style="display: grid; grid-template-columns: repeat(3, 250px); gap: 0px 10px;">
                                <button type="button" class="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-950 px-4 py-2 text-sm font-semibold text-slate-200 transition hover:border-slate-600 hover:bg-slate-600" (click)="submitGeneralInfoForm()">
                                    <i class="fas fa-edit"></i>
                                    <span>Update General Info</span>
                                </button>
                            </div>
                           
                        </mat-card>
                    </form><br>
                    <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                        <mat-card-header class="border-b border-slate-200 bg-slate-300/80 px-6 py-4">
                            <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                                <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-500/10 text-indigo-700">
                                    <i class="fas fa-address-card"></i>
                                </span>
                                <span>Contact Type List</span>
                            </mat-card-title>
                        </mat-card-header>   
                        <mat-card-content class="space-y-5 px-6 py-6">
                            <div style="text-align:right;" *ngIf="!typeExists" >
                                <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button style="border:background-color; color: rgb(35, 24, 134);color: #fdfdfd;" (click)="addType()">&nbsp;<i class="fa-solid fa-plus"></i>&nbsp;&nbsp;Add New Type</button>
                                </div>
                            </div>
                            <div *ngIf="typeExists">
                                <ag-grid-angular style="height: 200px; margin:20px"  
                                    [columnDefs]="typeColumnDefs" [rowData]="type_details"
                                    (cellEditingStopped)="onCellEditingStopped($event)"
                                    [defaultColDef]="defaultColDef">
                                </ag-grid-angular>                               
                            </div>                    
                        </mat-card-content>
                        <mat-card-header class="border-b border-slate-200 bg-slate-300/80 px-6 py-4">
                            <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                                <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-500/10 text-indigo-700">
                                    <i class="fas fa-www"></i>
                                </span>
                                <span>URL List</span>
                            </mat-card-title>
                        </mat-card-header>   
                        <mat-card-content class="space-y-5 px-6 py-6">
                            <div style="text-align:right;" *ngIf="!urlExists">
                                <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button style=" background-color: rgb(35, 24, 134);color: #fdfdfd;" (click)="addType()">&nbsp;<i class="fa-solid fa-plus"></i>&nbsp;&nbsp;Add New URL</button>
                                </div>
                            </div>                   
                            <div *ngIf="urlExists">
                                <ag-grid-angular style="height: 200px; margin:20px"  
                                    [columnDefs]="urlColumnDefs" [rowData]="url_details"
                                    (cellEditingStopped)="onCellEditingStopped($event)"
                                    [defaultColDef]="defaultColDef">
                                </ag-grid-angular>     
                            </div>      
                        </mat-card-content>
                        <mat-card-header class="border-b border-slate-200 bg-slate-300/80 px-6 py-4">
                            <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                                <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-500/10 text-indigo-700">
                                    <i class="fas fa-envelope"></i>
                                </span>
                                <span>Email List</span>
                            </mat-card-title>
                        </mat-card-header>       
                        <mat-card-content class="space-y-5 px-6 py-6">
                            <div style="text-align:right;" *ngIf="!emailExists" >
                                <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button style=" background-color: rgb(35, 24, 134);color: #fdfdfd;" (click)="addEmail()">&nbsp;<i class="fa-solid fa-plus"></i>&nbsp;&nbsp;Add New Email</button>
                                </div>
                            </div>
                            <div *ngIf="emailExists">
                                <ag-grid-angular style="height: 200px; margin:20px" 
                                    [columnDefs]="emailColumnDefs" [rowData]="email_details"
                                    (cellEditingStopped)="onCellEditingStopped($event)"
                                    [defaultColDef]="defaultColDef">
                                </ag-grid-angular>                               
                            </div>    
                        </mat-card-content>  
                        <mat-card-header class="border-b border-slate-200 bg-slate-300/80 px-6 py-4">
                            <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                                <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-500/10 text-indigo-700">
                                    <i class="fas fa-note"></i>
                                </span>
                                <span>Note List</span>
                            </mat-card-title>
                        </mat-card-header>               
                        <mat-card-content class="space-y-5 px-6 py-6">
                            <div style="text-align:right;" *ngIf="!noteExists" >
                                <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button style=" background-color: rgb(35, 24, 134);color: #fdfdfd;" (click)="addNote()">&nbsp;<i class="fa-solid fa-plus"></i>&nbsp;&nbsp;Add New Note</button>
                                </div>
                            </div>
                            <div *ngIf="noteExists">
                                <ag-grid-angular style="height: 200px; margin:20px"  
                                    [columnDefs]="noteColumnDefs" [rowData]="note_details"
                                    [defaultColDef]="defaultColDef">
                                </ag-grid-angular>                               
                            </div>         
                        </mat-card-content>                                                                              
                        <mat-card-header class="border-b border-slate-200 bg-slate-300/80 px-6 py-4">
                            <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                                <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-500/10 text-indigo-700">
                                    <i class="fas fa-alarm-exclamation"></i>
                                </span>
                                <span>Notification List</span>
                            </mat-card-title>
                        </mat-card-header>               
                        <mat-card-content class="space-y-5 px-6 py-6">
                            <div style="text-align:right;" *ngIf="!notificationExists" >
                                <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button style=" background-color: rgb(35, 24, 134);color: #fdfdfd;" (click)="addNotification()">&nbsp;<i class="fa-solid fa-plus"></i>&nbsp;&nbsp;Add New Notification</button>
                                </div>
                            </div>
                            <div *ngIf="notificationExists">
                                <ag-grid-angular style="height: 200px; margin:20px"  
                                    [columnDefs]="notificationColumnDefs" [rowData]="notification_details"
                                    [defaultColDef]="defaultColDef">
                                </ag-grid-angular>                               
                            </div>         
                        </mat-card-content>
                    </mat-card>  
                </div>
            </mat-tab>
            <mat-tab label="Addresses">
                <div class="p-4 pb-28 md:p-6 md:pb-32 xl:p-8 xl:pb-32">
                    <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                        <mat-card-header class="border-b border-slate-200 bg-slate-300/80 px-6 py-4">
                            <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                                <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-500/10 text-indigo-700">
                                    <i class="fas fa-house"></i>
                                </span>
                                <span>Address List</span>
                            </mat-card-title>
                        </mat-card-header>   
                        <mat-card-content class="space-y-5 px-6 py-6">
                            <div style="text-align:right;" *ngIf="!addressExists">
                                <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button style=" background-color: rgb(35, 24, 134);color: #fdfdfd;" (click)="addAddress()">&nbsp;<i class="fa-solid fa-plus"></i>&nbsp;&nbsp;Add New Address</button>
                                </div>
                            </div>
                            <div *ngIf="addressExists">
                                <ag-grid-angular style="height: 200px; margin:20px"  
                                    [columnDefs]="addressColumnDefs" [rowData]="address_details"
                                    [defaultColDef]="defaultColDef">
                                </ag-grid-angular>
                            </div>               
                        </mat-card-content>
                    </mat-card>
                </div>
            </mat-tab>
            <mat-tab label="Contacts">
                <div class="p-4 pb-28 md:p-6 md:pb-32 xl:p-8 xl:pb-32">
                    <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                        <mat-card-header class="border-b border-slate-200 bg-slate-300/80 px-6 py-4">
                            <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                                <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-500/10 text-indigo-700">
                                    <i class="fas fa-address-card"></i>
                                </span>
                                <span>Contact List</span>
                            </mat-card-title>
                        </mat-card-header>   
                        <mat-card-content class="space-y-5 px-6 py-6">
                            <div style="text-align:right;" *ngIf="!phoneExists">
                                <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button style=" background-color: rgb(35, 24, 134);color: #fdfdfd;" (click)="addPhone()">&nbsp;<i class="fa-solid fa-plus"></i>&nbsp;&nbsp;Add New Subcontact</button>
                                </div>
                            </div>
                            <div *ngIf="phoneExists">
                                <ag-grid-angular style="height: 200px; margin:20px"  
                                    [columnDefs]="subcontactColumnDefs" [rowData]="subcontact_details"
                                    [defaultColDef]="defaultColDef">
                                </ag-grid-angular>
                            </div>            
                        </mat-card-content>
                    </mat-card>         
                    <div *ngIf="operationsProfileExists">
                        <form [formGroup]="appointmentContactForm">
                        <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                            <mat-card-header class="border-b border-slate-200 bg-slate-300/80 px-6 py-4">
                                <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                                    <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-sky-500/10 text-sky-700">
                                    <i class="fas fa-person"></i>
                                    </span>
                                    <span>Appointment Contact Person</span>
                                </mat-card-title>
                            </mat-card-header>
                            <div class="wo-detail-section__panel">
                                <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-12">
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="name">Name</label>
                                            <input id="name" class="wo-inline-control" formControlName="name" />
                                            <input matInput type="string" formControlName="contact_uuid" hidden >       
                                            <input matInput type="string" formControlName="contact_profile_appointment_contact_uuid" hidden >                                          
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="email">Email</label>
                                            <input id="email" class="wo-inline-control" formControlName="email" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="phone_number">Phone Number</label>
                                            <input id="phone_number" class="wo-inline-control" formControlName="phone_number" />
                                        </div>
                                    </div>
                                    <div class="xl:col-span-2">
                                        <div class="wo-inline-field">
                                            <label class="wo-inline-label" for="mobile_number">Mobile</label>
                                            <input id="mobile_number" class="wo-inline-control" formControlName="mobile_number" />
                                        </div>
                                    </div>
                                </div>

                            </div>       
                            <div style="display: grid; grid-template-columns: repeat(3, 250px); gap: 0px 10px;">
                                <button type="button" class="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-950 px-4 py-2 text-sm font-semibold text-slate-200 transition hover:border-slate-600 hover:bg-slate-600" (click)="submitAppointmentForm()"  *ngIf="appointmentContactProfileExists">
                                    <i class="fas fa-edit"></i>
                                    <span>Update Appointment Contact Info</span>
                                </button>
                                <button type="button" class="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-950 px-4 py-2 text-sm font-semibold text-slate-200 transition hover:border-slate-600 hover:bg-slate-600" (click)="submitAppointmentForm()"  *ngIf="!appointmentContactProfileExists">
                                    <i class="fas fa-plus"></i>
                                    <span>Create New Appointment Contact Info</span>
                                </button>
                            </div>                                              
                        </mat-card>                            
                        </form>
                    </div>          
                </div>             
                <br><br>           
            </mat-tab>
            <mat-tab label="Operations Profile">
                <div class="p-4 pb-28 md:p-6 md:pb-32 xl:p-8 xl:pb-32">
                    <form [formGroup]="operationsForm">
                        <div style="display: flex; flex-direction: column; justify-content: space-between; gap: 1em; overflow-x:scroll; overflow-y: scroll">
                            <div>
                                <H2 style=" background-color: rgb(2, 110, 74);color: #fdfdfd;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-address-card"></i>&nbsp;&nbsp;Location Profile</H2>
                                <div style="display: grid; grid-template-columns: repeat(4, 300px); word-wrap: break-word">
                                    <mat-checkbox formControlName="loading_dock">
                                        Is there a loading dock?</mat-checkbox>
                                    <mat-checkbox formControlName="tailgate">
                                        Are tailgates required?</mat-checkbox>
                                    <mat-checkbox formControlName="ground_level">
                                        Off-load with forks at ground level </mat-checkbox>
                                    <mat-checkbox formControlName="truck_space">
                                        Is space available for a 53ft truck to park/offload?</mat-checkbox>
                                    <mat-checkbox formControlName="straight_truck">
                                        Is a straight truck required?</mat-checkbox>
                                    <mat-checkbox formControlName="high_cost">
                                        Is this a downtown or high cost area?</mat-checkbox>
                                    <mat-checkbox formControlName="convention_center">
                                        Is this a convention centre?</mat-checkbox>
                                    <mat-checkbox formControlName="pop_up">
                                        Is this a pop-up store?</mat-checkbox>
                                    <mat-checkbox formControlName="residential">
                                        Is this a private residence?</mat-checkbox>
                                    <mat-checkbox formControlName="elevator_inside">
                                        Is an elevator involved?</mat-checkbox>
                                    <mat-checkbox formControlName="delivery_inside">
                                        Does the freight need to be moved from the loading area to an inside
                                        location?</mat-checkbox>
                                    <mat-checkbox formControlName="hallway_corner">
                                        Does the hallway have corners>?</mat-checkbox>
                                </div>
                            </div>
                            <div>
                                <div style="display:flex; flex-direction: row; gap: 200px 100px">
                                    <div>
                                        <H2 style=" background-color: rgb(2, 110, 74);color: #fdfdfd;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-calendar-days"></i>&nbsp;&nbsp;Operating Days</H2>
                                        <div style="display: grid; grid-template-columns: repeat(2, 200px);">
                                            <mat-checkbox formControlName="to_friday">Monday to Friday</mat-checkbox>
                                            <mat-checkbox formControlName="to_saturday">Monday to Saturday</mat-checkbox>
                                            <mat-checkbox formControlName="to_thursday">Monday to Thursday</mat-checkbox>
                                            <mat-checkbox formControlName="seven_days">7 Days a Week</mat-checkbox>
                                            <mat-checkbox formControlName="monday_only">Mondays ONLY</mat-checkbox>
                                            <mat-checkbox formControlName="tuesday_only">Tuesdays ONLY</mat-checkbox>
                                            <mat-checkbox formControlName="wednesday_only">Wednesdays ONLY</mat-checkbox>
                                            <mat-checkbox formControlName="thursday_only">Thursdays ONLY</mat-checkbox>
                                            <mat-checkbox formControlName="friday_only">Fridays ONLY</mat-checkbox>
                                        </div>
                                    </div>
                                    <div>
                                        <H2 style=" background-color: rgb(2, 110, 74);color: #fdfdfd;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-clock"></i>&nbsp;&nbsp;Operating Hours</H2>
                                        <div style="display: grid; grid-template-columns: repeat(3, 250px); gap: 0px 10px;">
                                            <mat-checkbox formControlName="appointments">Are Appointments
                                                required?</mat-checkbox>
                                            <mat-checkbox formControlName="after_hours">Are after-hours
                                                accomodated?</mat-checkbox>
                                            <mat-checkbox formControlName="access_loading">Limited time access to
                                                loading/unloading area?</mat-checkbox>
                                            <mat-form-field>
                                                <mat-label>Default Appointment Start Time</mat-label>
                                                <input matInput type="time" formControlName="appointment_start">
                                            </mat-form-field>
                                            <mat-form-field>
                                                <mat-label>Default Appointment End Time</mat-label>
                                                <input matInput type="time" formControlName="appointment_end">
                                            </mat-form-field>
                                            <mat-form-field>
                                                <mat-label>Default Appointment Day</mat-label>
                                                <input matInput formControlName="appointment_day">
                                            </mat-form-field>
                                            <mat-form-field>
                                                <mat-label>Opening Time</mat-label>
                                                <input matInput formControlName="opening_time">
                                            </mat-form-field>
                                            <mat-form-field>
                                                <mat-label>Closing Time</mat-label>
                                                <input matInput formControlName="closing_time">
                                                <input matInput type="string" formControlName="contact_uuid" hidden >   
                                                <input matInput type="string" formControlName="contact_profile_uuid" hidden >                                                
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div
                            style="display: flex; flex-direction: column; justify-content: space-between; gap: 1em; overflow-x:scroll; overflow-y: scroll">
                            <div>
                                <H2 style=" background-color: rgb(110, 2, 96);color: #fdfdfd; margin-left: 10px;">&nbsp;<i class="fa-solid fa-cart"></i>&nbsp;&nbsp; Market Areas</H2>
                                <div style="display:flex; flex-direction: row; gap: 100px 20px">
                                    <div style="display: grid; grid-template-columns: repeat(3, 200px);">
                                        <mat-checkbox formControlName="interprovincial">Interprovincial</mat-checkbox>
                                        <mat-checkbox formControlName="intraprovincial">Intraprovincial</mat-checkbox>
                                        <mat-checkbox formControlName="canada_us_border">Canada US
                                            Crossborder</mat-checkbox>
                                        <mat-checkbox formControlName="interstate">Interstate</mat-checkbox>
                                        <mat-checkbox formControlName="intrastate">Intrastate</mat-checkbox>
                                    </div>
                                    <div style="display: grid; grid-template-columns: repeat(1, 200px); gap: 0px 10px;">
                                        <mat-form-field>
                                            <mat-label>Province</mat-label>
                                            <input matInput formControlName="operation_profile_province">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>State</mat-label>
                                            <input matInput formControlName="operation_profile_state">
                                        </mat-form-field>
                                    </div>
                                    <div>
                                        <div
                                            style="display: grid; grid-template-columns: repeat(4, 200px); word-wrap: break-word">
                                            <mat-checkbox formControlName="mexico_border">US
                                                Mexico Crossboarder</mat-checkbox>
                                            <mat-checkbox formControlName="canada_west">Canada West</mat-checkbox>
                                            <mat-checkbox formControlName="canada_central">Canada Central</mat-checkbox>
                                            <mat-checkbox formControlName="canada_east">Canada East</mat-checkbox>
                                            <mat-checkbox formControlName="usa_new_england">USA New England</mat-checkbox>
                                            <mat-checkbox formControlName="usa_mid_atlantic">USA Mid Atlantic</mat-checkbox>
                                            <mat-checkbox formControlName="usa_great_lakes">USA Great Lakes</mat-checkbox>
                                            <mat-checkbox formControlName="usa_mid_west">USA Mid-West</mat-checkbox>
                                            <mat-checkbox formControlName="usa_south_atlantic">USA South
                                                Atlantic</mat-checkbox>
                                            <mat-checkbox formControlName="usa_southeast">USA Southeast</mat-checkbox>
                                            <mat-checkbox formControlName="usa_south_central">USA South
                                                Central</mat-checkbox>
                                            <mat-checkbox formControlName="usa_mountain">USA Mountain</mat-checkbox>
                                            <mat-checkbox formControlName="usa_pacific">USA Pacific</mat-checkbox>
                                            <mat-checkbox formControlName="usa_far_pacific">USA Far Pacific</mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div style="display:flex; flex-direction: row; gap: 100px 20px">
                                    <div>
                                        <H2 style=" background-color: rgb(110, 2, 96);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-truck"></i>&nbsp;&nbsp; Transportation Requirements</H2>
                                        <div
                                            style="display: grid; grid-template-columns: repeat(4, 200px); word-wrap: break-word">
                                            <mat-checkbox formControlName="use_csa">CSA</mat-checkbox>
                                            <mat-checkbox formControlName="use_fast">FAST</mat-checkbox>
                                            <mat-checkbox formControlName="use_ace">ACE</mat-checkbox>
                                            <mat-checkbox formControlName="use_aci">ACI</mat-checkbox>
                                            <mat-checkbox formControlName="use_ct_pat">CT PAT</mat-checkbox>
                                            <mat-checkbox formControlName="use_can_bond">Canada BOND</mat-checkbox>
                                            <mat-checkbox formControlName="use_us_bond">US BOND</mat-checkbox>
                                            <mat-checkbox formControlName="use_hazmat">HAZMAT</mat-checkbox>
                                            <mat-checkbox formControlName="protect_freezing">Protect From
                                                Freezing</mat-checkbox>
                                            <mat-checkbox formControlName="heated">Heated</mat-checkbox>
                                            <mat-checkbox formControlName="refrigeration">Refrigeration</mat-checkbox>
                                            <mat-checkbox formControlName="use_food_grade">Food Grade</mat-checkbox>
                                        </div>
                                    </div>
                                    <div>
                                        <H2 style=" background-color: rgb(110, 2, 96);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-file-doc"></i>&nbsp;&nbsp; Documentation Requirements</H2>
                                        <div
                                            style="display: grid; grid-template-columns: repeat(4, 200px); word-wrap: break-word">
                                            <mat-checkbox formControlName="bol_shipping">Shipping BOL</mat-checkbox>
                                            <mat-checkbox formControlName="bol_invoice">Invoice BOL</mat-checkbox>
                                            <mat-checkbox formControlName="pod_invoice">Invoice POD</mat-checkbox>
                                            <mat-checkbox formControlName="purchase_order_number_invoice">Purchase Order
                                                Number</mat-checkbox>
                                            <mat-checkbox formControlName="rate_quote_copy">Rate Quote</mat-checkbox>
                                            <mat-checkbox formControlName="pick_up_reference_number">Pick-up
                                                Reference</mat-checkbox>
                                            <mat-checkbox formControlName="delivery_reference_number">Delivery
                                                Reference</mat-checkbox>
                                                <input matInput type="string" formControlName="contact_uuid" hidden >   
                                                <input matInput type="string" formControlName="contact_profile_uuid" hidden >                                                
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <div style="margin-bottom: 10px">
                                        <button mat-raised-button style=" background-color: rgb(0, 255, 55);color: #000000;"  *ngIf="operationsProfileExists"
                                            (click)="submitOperationsForm()">Update Changes</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <button mat-raised-button style=" background-color: rgb(255, 0, 0);color: #fdfdfd;" 
                                            *ngIf="!operationsProfileExists"
                                            (click)="submitOperationsForm()">Create New Operations Profile</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>               
                </div>
            </mat-tab>
            <mat-tab label="Services"><br>
                <div class="p-4 pb-28 md:p-6 md:pb-32 xl:p-8 xl:pb-32">
                    <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                        <mat-card-header class="border-b border-slate-200 bg-slate-300/80 px-6 py-4">
                            <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                                <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-sky-500/10 text-sky-700">
                                <i class="fas fa-gear"></i>
                                </span>
                                <span>Services</span>
                            </mat-card-title>
                        </mat-card-header>
                        <mat-card-content class="space-y-5 px-6 py-6">
                            <div style="text-align:right;">
                                <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button style=" background-color: rgb(35, 24, 134);color: #fdfdfd;" *ngIf="!carrierServiceExists" (click)="addService()">&nbsp;<i class="fa-solid fa-plus"></i>&nbsp;&nbsp;Add New Service</button>
                                </div>
                            </div>              
                            <ag-grid-angular style="height: 250px; margin:20px"  
                                [columnDefs]="serviceRatesColumnDefs" [rowData]="service_rates"
                                (cellEditingStopped)="onCellEditingStopped($event)"
                                [defaultColDef]="defaultColDef">
                            </ag-grid-angular>
                        </mat-card-content>
                    </mat-card>         
                    <mat-card class="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-none">
                        <mat-card-header class="border-b border-slate-200 bg-slate-300/80 px-6 py-4">
                            <mat-card-title class="flex items-center gap-3 text-2xl font-semibold tracking-tight text-slate-900">
                                <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-sky-500/10 text-sky-700">
                                <i class="fas fa-gear"></i>
                                </span>
                                <span>Default Services</span>
                            </mat-card-title>
                        </mat-card-header>
                        <mat-card-content class="space-y-5 px-6 py-6">
                            <div style="text-align:right;">
                                <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button style=" background-color: rgb(35, 24, 134);color: #fdfdfd;" *ngIf="!serviceExists" (click)="addDefaultService()">&nbsp;<i class="fa-solid fa-plus"></i>&nbsp;&nbsp;Add New Default Service</button>
                                </div>
                            </div>
                            <ag-grid-angular style="height: 250px; margin:20px"  
                                [columnDefs]="defaultServicesColumnDefs" [rowData]="contact_profile_default_services"
                                (cellEditingStopped)="onCellEditingStopped($event)"
                                [defaultColDef]="defaultColDef">
                            </ag-grid-angular>

                        </mat-card-content>
                    </mat-card>                       
                </div>
            </mat-tab>
            <mat-tab label="Accounting Profile">
                <div class="p-4 pb-28 md:p-6 md:pb-32 xl:p-8 xl:pb-32">
                    <form [formGroup]="accountingForm">
                        <div
                            style="display: flex; flex-direction: column; justify-content: space-between; gap: 1em; overflow-x:scroll;">
                            <div>
                                <H2 style=" background-color: rgb(95, 202, 7);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-dollar"></i><i style="font-size: 30px;" class="fa-solid fa-wrench"></i>&nbsp;&nbsp; Finance Tools</H2>
                                <div style="display:flex; flex-direction: row; gap: 0px 40px">
                                    <div
                                        style="display: grid; grid-template-columns: repeat(3, 200px); gap: 0px 10px; word-wrap: break-word">
                                        <mat-checkbox formControlName="on_hold" value={{accounting_profile.on_hold}}>On
                                            Hold</mat-checkbox>
                                        <mat-form-field>
                                            <mat-label>Batch No</mat-label>
                                            <input matInput formControlName="ap_batch_number">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Accounting Code</mat-label>
                                            <input matInput formControlName="accounting_code">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Carrier Code</mat-label>
                                            <input matInput formControlName="carrier_code">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Payment Term</mat-label>
                                            <input matInput formControlName="payment_terms">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Fuel Surcharged</mat-label>
                                            <input matInput formControlName="fuel_surcharged">
                                        </mat-form-field>
                                    </div>
                                    <div
                                        style="display: grid; grid-template-columns: repeat(4, 200px); gap: 0px 10px; word-wrap: break-word">
                                        <mat-checkbox value={{accounting_profile.tax_applied}}
                                            formControlName="tax_applied">Tax
                                            Applied</mat-checkbox>
                                        <mat-checkbox [checked]="isChecked('ab_carbon_fuel_tax', 'accounting_profile')"
                                            formControlName="ab_carbon_fuel_tax">Alberta Carbon Fuel Tax
                                            Applied</mat-checkbox>
                                        <mat-checkbox [checked]="isChecked('bc_carbon_fuel_tax', 'accounting_profile')"
                                            formControlName="bc_carbon_fuel_tax">BC Carbon Fuel Tax Applied</mat-checkbox>
                                        <mat-form-field>
                                            <mat-label>Tax Jurisdiction</mat-label>
                                            <input matInput formControlName="tax_jurisdiction">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Canada Tax ID</mat-label>
                                            <input matInput formControlName="can_tax_id">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>UFOS ACCPACC ID</mat-label>
                                            <input matInput formControlName="ufos_accpac_id">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Tax ID Number</mat-label>
                                            <input matInput formControlName="tax_id_number">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div>
                                    <div
                                        style="display: grid; grid-template-columns: repeat(9, 200px); gap: 0px 10px; word-wrap: break-word">
                                        <mat-form-field>
                                            <mat-label>Account Type</mat-label>
                                            <input matInput formControlName="account_type">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Account Currency</mat-label>
                                            <input matInput formControlName="account_currency">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Account Status</mat-label>
                                            <input matInput formControlName="account_status">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Account Note</mat-label>
                                            <input matInput formControlName="accounting_note">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Account Balance</mat-label>
                                            <input matInput formControlName="account_balance">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Account Balance Date</mat-label>
                                            <input matInput formControlName="account_balance_date">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Account Balance Days</mat-label>
                                            <input matInput formControlName="account_balance_days">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Credit Limit</mat-label>
                                            <input matInput formControlName="credit_limit">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Interest Rate</mat-label>
                                            <input matInput formControlName="interest_rate">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <H2 style=" background-color: rgb(95, 202, 7);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-document"></i>&nbsp;&nbsp; Invoice Details</H2>
                                <div style="display:flex; flex-direction: row; gap: 0px 40px">
                                    <div
                                        style="display: grid; grid-template-columns: repeat(3, 200px); gap: 0px 10px; word-wrap: break-word">
                                        <mat-form-field>
                                            <mat-label>Report Group</mat-label>
                                            <input matInput formControlName="report_group">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Pay Term</mat-label>
                                            <input matInput formControlName="pay_term">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Billing Code</mat-label>
                                            <input matInput formControlName="billing_code">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Specify Time</mat-label>
                                            <input matInput formControlName="specify_time">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Customs Charges</mat-label>
                                            <input matInput formControlName="customs_charges">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Warehouse Charge</mat-label>
                                            <input matInput formControlName="warehouse_charge">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Freight Insurance</mat-label>
                                            <input matInput formControlName="freight_insurance">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Insurance Percentage</mat-label>
                                            <input matInput formControlName="insurance_percentage">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Insurance Minimum</mat-label>
                                            <input matInput formControlName="insurance_minimum">
                                        </mat-form-field>
                                    </div>
                                    <div
                                        style="display: grid; grid-template-columns: repeat(3, 200px); gap: 0px 10px; word-wrap: break-word">
                                        <mat-form-field>
                                            <mat-label>Pickup Rate</mat-label>
                                            <input matInput formControlName="pickup_rate">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Delivery Rate</mat-label>
                                            <input matInput formControlName="delivery_rate">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Hourly Rate</mat-label>
                                            <input matInput formControlName="hourly_rate">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Skid Fee</mat-label>
                                            <input matInput formControlName="skid_fee">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>DUNS Number</mat-label>
                                            <input matInput formControlName="duns_number">
                                        </mat-form-field>
                                        <mat-checkbox [checked]="isChecked('express_road', 'accounting_profile')"
                                            formControlName="express_road">Express Road</mat-checkbox>
                                        <mat-form-field>
                                            <mat-label>Invoice Comment</mat-label>
                                            <input matInput formControlName="invoice_comment">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Invoice Note</mat-label>
                                            <input matInput formControlName="invoice_note">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Default Cube Factor</mat-label>
                                            <input matInput formControlName="default_cube_factor">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div>
                                    <div style="display: flex; flex-direction: column; gap: 30px">
                                        <div style="align-items: center; justify-content: center;">
                                            <button mat-raised-button style=" background-color: rgb(0, 255, 55);color: #000000;"  *ngIf="accountingProfileExists"
                                                (click)="submitAccountingForm()">Update
                                                Changes</button>
                                        </div>
                                        <div style="align-items: center; justify-content: center;">
                                            <button mat-raised-button style=" background-color: rgb(255, 0, 0);color: #fdfdfd;" 
                                                *ngIf="!accountingProfileExists"
                                                (click)="submitAccountingForm()">Create New Accounting Profile</button>
                                        </div>
                                    </div>
                                    <!-- <div style="align-items: center; justify-content: center;">
                                        <button mat-raised-button color="primary" (click)="submitAccountingForm()">Update</button>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </mat-tab>
            <!-- DOCUMENTS TAB -->
            <mat-tab label="Documents">
                <div class="p-4 pb-28 md:p-6 md:pb-32 xl:p-8 xl:pb-32">
                    <!-- DOCUMENT UPLOAD + DOCUMENT TABLE -->
                    <div class="documents-section">
                        <H2 style=" background-color: rgb(15, 32, 1);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-file-arrow-up"></i>&nbsp;&nbsp; Documents</H2>
                        <br><br>
                        <div
                        class="document-drop-area"
                        (dragover)="handleDocumentDragOver($event)"
                        (dragleave)="handleDocumentDragLeave($event)"
                        (drop)="handleDocumentDrop($event)"
                        [ngClass]="{ 'dragging-over': isDraggingOverDocument }"
                        >
                        <p><span style="border-width:5px; border-style:dotted;; border-color:#FF0000; padding: 2em;"><i class="fas fa-upload"></i> Drag and drop files here to upload</span></p><br>
                        </div>

                        <h3 class="section-title">Documents</h3>

                        <mat-table [dataSource]="documentsTable" class="mat-elevation-z8">

                        <!-- FILE NAME -->
                        <ng-container matColumnDef="file_name">
                            <mat-header-cell *matHeaderCellDef> File Name </mat-header-cell>
                            <mat-cell *matCellDef="let document"> {{ document.file_name }} </mat-cell>
                        </ng-container>

                        <!-- FILE TYPE -->
                        <ng-container matColumnDef="file_type">
                            <mat-header-cell *matHeaderCellDef> File Type </mat-header-cell>
                            <mat-cell *matCellDef="let document"> {{ document.file_type }} </mat-cell>
                        </ng-container>

                        <!-- ACTIONS -->
                        <ng-container matColumnDef="actions">
                            <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                            <mat-cell *matCellDef="let document">

                            <!-- PDF (open in new tab) -->
                            <button mat-icon-button color="primary"
                                    *ngIf="document.file_format.toLowerCase() === 'pdf'"
                                    (click)="openDocument(document)">
                                <i class="fas fa-file-pdf"></i>
                            </button>

                            <!-- Word (open in new tab) -->
                            <button mat-icon-button color="primary"
                                    *ngIf="document.file_format.toLowerCase() === 'doc'"
                                    (click)="openDocument(document)">
                                <i class="fas fa-file-word"></i>
                            </button>

                            <!-- TIFF/TIF (download) -->
                            <button mat-icon-button color="primary"
                                    *ngIf="['tif','tiff'].includes(document.file_format.toLowerCase())"
                                    (click)="openDocument(document)">
                                <i class="fas fa-file-download"></i>
                            </button>

                            <!-- Images (open in modal) -->
                            <button mat-icon-button color="primary"
                                    *ngIf="!['pdf','tif','tiff', 'doc'].includes(document.file_format.toLowerCase())"
                                    (click)="openDocument(document)">
                                <i class="fas fa-image"></i>
                            </button>

                            <!-- Delete -->
                            <button mat-icon-button color="primary"
                                    (click)="deleteDocument(document)">
                                <i class="fas fa-trash"></i>
                            </button>

                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

                        </mat-table>
                    </div>

                </div>
            </mat-tab>
            <!-- WSIB/W9 Form TAB -->
            <mat-tab label="Forms">
                <div class="p-4 pb-28 md:p-6 md:pb-32 xl:p-8 xl:pb-32">
                    <form [formGroup]="wisbForm">
                        <div style="display: flex; flex-direction: column; justify-content: space-between; gap: 1em; overflow-x:scroll;">
                            <div>
                                <H2 style=" background-color: rgb(59, 7, 202);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-file"></i>&nbsp;&nbsp; WISB Form</H2>
                                <div style="display:flex; flex-direction: row; gap: 0px 40px">
                                    <div
                                        style="display: grid; grid-template-columns: repeat(6, 250px); gap: 0px 10px; word-wrap: break-word">
                                        <mat-form-field>
                                            <mat-label>Legal Name</mat-label>
                                            <input matInput formControlName="legal_name">
                                            <input matInput type="string" formControlName="wisb_form_uuid" hidden >  
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Business Name</mat-label>
                                            <input matInput formControlName="business_name">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>US Tax ID Number</mat-label>
                                            <input matInput formControlName="us_taxpayer_id_no">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>WSIB/W9 Account Number</mat-label>
                                            <input matInput formControlName="wisb_account_no">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Other</mat-label>
                                            <input matInput formControlName="other">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Individual Proprietor</mat-label>
                                            <input matInput formControlName="individual_proprietor">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>C Corporation</mat-label>
                                            <input matInput formControlName="c_corporation">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>S Corporation</mat-label>
                                            <input matInput formControlName="s_corportation">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Partnership</mat-label>
                                            <input matInput formControlName="partnership">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Trust Estate</mat-label>
                                            <input matInput formControlName="trust_estate">
                                        </mat-form-field>                                                                                                                                                
                                        <mat-form-field>
                                            <mat-label>LLC LLP</mat-label>
                                            <input matInput formControlName="llc_llp">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Exempt Payee</mat-label>
                                            <input matInput formControlName="exempt_payee">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Address Street</mat-label>
                                            <input matInput formControlName="address_street">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Address Extended</mat-label>
                                            <input matInput formControlName="address_extended">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Address City</mat-label>
                                            <input matInput formControlName="address_locality">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Address Provice/State</mat-label>
                                            <input matInput formControlName="address_region">
                                        </mat-form-field>       
                                        <mat-form-field>
                                            <mat-label>Address Country</mat-label>
                                            <input matInput formControlName="address_country">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Address Postal Code</mat-label>
                                            <input matInput formControlName="address_postal_code">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>WISB Certificate No</mat-label>
                                            <input matInput formControlName="wisb_certificate_no">
                                        </mat-form-field>     
                                        <mat-form-field>
                                            <mat-label>WISB Certificate Valid</mat-label>
                                            <input matInput [matDatepicker]="wisbCertificateDatePicker" formControlName="wisb_certificate_valid" />
                                            <mat-datepicker-toggle matSuffix [for]="wisbCertificateDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker #wisbCertificateDatePicker></mat-datepicker>                                             
                                        </mat-form-field>                                                                                                  
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div style="display: flex; flex-direction: column; gap: 30px">
                                    <div style="align-items: center; justify-content: center;">
                                        <button mat-raised-button style=" background-color: rgb(0, 255, 55);color: #000000;"  *ngIf="wisbFormExists"
                                            (click)="submitWISBForm()">Update
                                            Changes</button>
                                    </div>
                                    <div style="align-items: center; justify-content: center;">
                                        <button mat-raised-button style=" background-color: rgb(255, 0, 0);color: #fdfdfd;"  *ngIf="!wisbFormExists"
                                            (click)="submitWISBForm()">Create New WSIB Form</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <form [formGroup]="insuranceForm">
                        <div style="display: flex; flex-direction: column; justify-content: space-between; gap: 1em; overflow-x:scroll;">
                            <div>
                                <H2 style=" background-color: rgb(59, 7, 202);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-file"></i>&nbsp;&nbsp; Insurance Form</H2>
                                <div style="display:flex; flex-direction: row; gap: 0px 40px">
                                    <div
                                        style="display: grid; grid-template-columns: repeat(6, 250px); gap: 0px 10px; word-wrap: break-word">
                                        <mat-form-field>
                                            <mat-label>Policy No</mat-label>
                                            <input matInput formControlName="policy_no">
                                            <input matInput type="string" formControlName="insurance_form_uuid" hidden >  
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>GL Expires</mat-label>
                                            <input matInput [matDatepicker]="glExpiresDatePicker" formControlName="gl_expires" />
                                            <mat-datepicker-toggle matSuffix [for]="glExpiresDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker #glExpiresDatePicker></mat-datepicker>                                        
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>GL Limit</mat-label>
                                            <input matInput formControlName="gl_limit">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Auto Expires</mat-label>
                                            <input matInput [matDatepicker]="autoExpireDatePicker" formControlName="auto_expires" />
                                            <mat-datepicker-toggle matSuffix [for]="autoExpireDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker #autoExpireDatePicker></mat-datepicker>                                        
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Auto Limit</mat-label>
                                            <input matInput formControlName="auto_limit">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Cargo Expires</mat-label>
                                            <input matInput [matDatepicker]="cargoExpiresDatePicker" formControlName="cargo_expires" />
                                            <mat-datepicker-toggle matSuffix [for]="cargoExpiresDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker #cargoExpiresDatePicker></mat-datepicker>                                        
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Cargo Limit</mat-label>
                                            <input matInput formControlName="cargo_limit">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>WC Expires</mat-label>
                                            <input matInput [matDatepicker]="wcExpiresDatePicker" formControlName="wc_expires" />
                                            <mat-datepicker-toggle matSuffix [for]="wcExpiresDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker #wcExpiresDatePicker></mat-datepicker>                                        
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Insurance Agent Information</mat-label>
                                            <input matInput formControlName="insurance_agent_information">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Agent Phone</mat-label>
                                            <input matInput formControlName="agent_phone">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Agent Fax</mat-label>
                                            <input matInput formControlName="agent_fax">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Description</mat-label>
                                            <input matInput formControlName="description">
                                        </mat-form-field>       
                                        <mat-form-field>
                                            <mat-label>Agent Contact UUID</mat-label>
                                            <input matInput formControlName="agent_contact_uuid">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Agent Name</mat-label>
                                            <input matInput formControlName="agent_name">
                                        </mat-form-field><br>
                                        <mat-checkbox [checked]="isChecked('previous_theft_claim', 'insurance_form')" formControlName="previous_theft_claim">
                                            Previous Theft Claim
                                        </mat-checkbox>                                      
                                        <mat-checkbox [checked]="isChecked('computers', 'insurance_form')" formControlName="computers">
                                            Computers
                                        </mat-checkbox>                                      
                                        <mat-checkbox [checked]="isChecked('electronics', 'insurance_form')" formControlName="electronics">
                                            Electronics
                                        </mat-checkbox>                                      
                                        <mat-checkbox [checked]="isChecked('liguor', 'insurance_form')" formControlName="liguor">
                                            Liquor
                                        </mat-checkbox>                                      
                                        <mat-checkbox [checked]="isChecked('theft', 'insurance_form')" formControlName="theft">
                                            Theft
                                        </mat-checkbox>                                      
                                        <mat-checkbox [checked]="isChecked('unsecure_yard', 'insurance_form')" formControlName="unsecure_yard">
                                            Insecure Yard
                                        </mat-checkbox>                                      
                                        <mat-form-field>
                                            <mat-label>Other Exclusion</mat-label>
                                            <input matInput formControlName="other_exclusion">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Agent Email</mat-label>
                                            <input matInput formControlName="agent_email">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Licensing</mat-label>
                                            <input matInput formControlName="licensing">
                                        </mat-form-field>                                                                                                                                                                                                                                                                                                                                                         
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div style="display: flex; flex-direction: column; gap: 30px">
                                    <div style="align-items: center; justify-content: center;">
                                        <button mat-raised-button style=" background-color: rgb(0, 255, 55);color: #000000;"  *ngIf="insuranceFormExists"
                                            (click)="submitInsuranceForm()">Update
                                            Changes</button>
                                    </div>
                                    <div style="align-items: center; justify-content: center;">
                                        <button mat-raised-button style=" background-color: rgb(255, 0, 0);color: #fdfdfd;"  *ngIf="!insuranceFormExists"
                                            (click)="submitInsuranceForm()">Create New Insurance Form</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </mat-tab>
            <!-- sales Profile TAB -->
            <mat-tab label="Sales Profile">
                <div class="p-4 pb-28 md:p-6 md:pb-32 xl:p-8 xl:pb-32">
                    <form [formGroup]="salesProfileForm">
                        <div style="display: flex; flex-direction: column; justify-content: space-between; gap: 1em; overflow-x:scroll;">
                            <div>
                                <H2 style=" background-color: rgb(59, 7, 202);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-dollar"></i>&nbsp;&nbsp;Sales Profile</H2>
                                <div style="display:flex; flex-direction: row; gap: 0px 40px">
                                    <div style="display: grid; grid-template-columns: repeat(6, 250px); gap: 0px 10px; word-wrap: break-word">
                                        <mat-form-field>
                                            <mat-label>Sales Status</mat-label>
                                            <mat-select formControlName="sales_status" >
                                                <mat-option *ngFor="let type of typeListSalesStatus"
                                                    [value]="type">{{type}}</mat-option>
                                            </mat-select>                                        
                                            <input matInput formControlName="sales_status">
                                            <input matInput type="string" formControlName="sales_profile_uuid" hidden >  
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Last Action</mat-label>
                                            <input matInput formControlName="last_action">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Username</mat-label>
                                            <input matInput formControlName="username">
                                        </mat-form-field>        
                                        <mat-form-field>
                                            <mat-label>Tradeshow Freight</mat-label>
                                            <input matInput formControlName="tradeshow_freight">
                                        </mat-form-field> 
                                        <mat-form-field>
                                            <mat-label>Action Type</mat-label>
                                            <mat-select formControlName="action_type" >
                                                <mat-option *ngFor="let type of typeListAction"
                                                    [value]="type">{{type}}</mat-option>
                                            </mat-select>                                           
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Drip Status</mat-label>
                                            <input matInput formControlName="drip_status">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Sales Potential</mat-label>
                                            <input matInput formControlName="sales_potential">
                                        </mat-form-field>                                    
                                        <mat-form-field>
                                            <mat-label>Sales Manager</mat-label>
                                            <mat-select formControlName="sales_manager" >
                                                <mat-option *ngFor="let type of typeListSalesManager"
                                                    [value]="type">{{type}}</mat-option>
                                            </mat-select>                                               
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Current Provider</mat-label>
                                            <input matInput formControlName="current_provider">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Sales Evaluation</mat-label>
                                            <mat-select formControlName="sales_evaluation" >
                                                <mat-option *ngFor="let type of typeListSalesEvaluation"
                                                    [value]="type">{{type}}</mat-option>
                                            </mat-select>                                           
                                        </mat-form-field>                                                                                                                                                                                                                                             
                                        <br>      
                                        <mat-checkbox [checked]="isChecked('cross_border', 'sales_profile')" formControlName="cross_border">
                                            Cross Border
                                        </mat-checkbox>       
                                        <mat-checkbox [checked]="isChecked('us_only', 'sales_profile')" formControlName="us_only">
                                            US Only
                                        </mat-checkbox>                                                                                                                                     
                                        <mat-checkbox [checked]="isChecked('canada_only', 'sales_profile')" formControlName="canada_only">
                                            Canada Only
                                        </mat-checkbox>                                                                                                                                     
                                        <mat-checkbox [checked]="isChecked('warehouse_distribution', 'sales_profile')" formControlName="warehouse_distribution">
                                            Warehouse Distribution
                                        </mat-checkbox>               
                                        <mat-checkbox [checked]="isChecked('specialized_services', 'sales_profile')" formControlName="specialized_services">
                                            Specialized Services
                                        </mat-checkbox>                 
                                        <mat-checkbox [checked]="isChecked('tradeshow_freight', 'sales_profile')" formControlName="tradeshow_freight">
                                            Tradeshow Freight
                                        </mat-checkbox>            
                                        <mat-checkbox [checked]="isChecked('trailer_build', 'sales_profile')" formControlName="trailer_build">
                                            Trailer Build
                                        </mat-checkbox>     
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div style="display: flex; flex-direction: column; gap: 30px">
                                    <div style="align-items: center; justify-content: center;">
                                        <button mat-raised-button style=" background-color: rgb(0, 255, 55);color: #000000;"  *ngIf="salesProfileExists"
                                            (click)="submitSalesProfile()">Update
                                            Changes</button>
                                    </div>
                                    <div style="align-items: center; justify-content: center;">
                                        <button mat-raised-button style=" background-color: rgb(255, 0, 0);color: #fdfdfd;"  *ngIf="!salesProfileExists"
                                            (click)="submitSalesProfile()">Create Sales Profile</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </mat-tab>


        </mat-tab-group>
    </div>    
    </div>     
</app-menu>